import GetJsonView from "./GetJsonView";

const JsonViewer = ({ value = {}, className }) => (
  <div className={`font-mono text-sm text-gray-50 pl-1 ${className}`}>
    <GetJsonView object={value} />
  </div>
);

export default JsonViewer;
